import { useCallback, useState } from 'react'
import { FormDialog } from 'components/dialog/form'
import { InviteResult } from 'interface/user/invite'
import { GroupResult } from 'interface/user/group'
import { InviteApplovalForm, useInviteApplovalForm } from '../form/apploval'
import { InviteRejectDialog } from './reject'
import { Alert, AlertTitle, Button } from '@mui/material'
import { TrushIcon } from 'shared/icons'

type InviteApplovalDialogProps = {
  invite: InviteResult
  groupList: GroupResult[],
  onApplovalInvite: (inviteId: number) => void
  onRejectInvite: (inviteId: number) => void
  onClose: () => void
}
export const InviteApplovalDialog = ({
  invite,
  groupList,
  onApplovalInvite,
  onRejectInvite,
  onClose
}: InviteApplovalDialogProps) => {
  const [modal, setModal] = useState<'reject' | null>(null)
  const onApplovaled = useCallback(
    (approvaledId: number) => {
      onApplovalInvite(approvaledId)
      onClose()
    },
    [onClose, onApplovalInvite]
  )
  const form = useInviteApplovalForm({
    invite,
    groupList,
    onApplovaled
  })
  return (
    <>
      <FormDialog
        open
        fullWidth
        maxWidth="sm"
        title={"招待申請の承認"}
        isLoading={form.posting}
        error={form.error}
        note={(
          <Alert severity="info">
            <AlertTitle>招待申請を承認します</AlertTitle>
            内容を確認のうえ、割り当てグループを指定してください。
          </Alert>
        )}
        body={<InviteApplovalForm {...form}/>}
        leftAction={
          <>
            <Button
              variant="contained"
              color="error"
              size="large"
              startIcon={<TrushIcon/>}
              onClick={() => setModal("reject")}
            >
              拒否
            </Button>
          </>
        }
        submitLabel="承認"
        isValid={form.formState.isValid}
        onSubmit={form.apploval}
        onClose={onClose}
      />
      {modal === 'reject' ? (
        <InviteRejectDialog
          invite={invite}
          onRejectInvite={inviteId => {
            setModal(null)
            onRejectInvite(inviteId)
            onClose()
          }}
          onClose={() => {
            setModal(null)
          }}
        />
      ) : <></>}
    </>
  )
}
